module.exports = __webpack_public_path__ + "img/appBrand--fc-full.f1a85bea.svg";